<template>
  <v-divider class="rc-divider"></v-divider>
</template>

<script setup>
</script>

<style scoped>

.rc-divider {
  border-top: 1px solid rgba(0, 0, 0) !important;
}

.v-theme--dark .rc-divider {
  border-top-color: rgba(255, 255, 255) !important;
}
</style>